/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useContext, useCallback, useState, useEffect } from 'react'

import { CurrentUserContext } from '../../../../Contexts'
import { useCallbackStatic } from '../../../../hooks/utils'

import getDeviceInfos from '../../../../utils/getDeviceInfos'
import { uploadFirestore } from './firestore'

import originConsents from '../../../../constants/originConsents'
import sendUserConsent from '../../../../utils/sendUserConsent'

const Base = ({
  title,
  description,
  imagePath,
  form,
  setForm,
  tipoTermo,
  salvarOk,
  db,
  availableTicketsAmmount,
  availableTicketsAmmountRef
}) => {
  const { currentUser } = useContext(CurrentUserContext)
  const [userTicket, setUserTicket] = useState('')
  const [result, setResult] = useState(false)
  const [loading, setLoading] = useState(false)
  const [hasError, setHasError] = useState(undefined)

  // console.log(userIdToken)

  useEffect(() => {
   if(!currentUser) {
    setHasError('Usuário não autenticado')
   }
  }, [currentUser])

  const back = useCallbackStatic(() => {
    setResult(false)
    window.location.reload()
  })

  const cleanDataState = useCallback(() => {
    const cleanedForm = {}
    Object.keys(form).forEach((key) => {
      cleanedForm[`${key}`] = ''
    })
    cleanedForm.termoAceito = false
    setForm(() => cleanedForm)
    setResult(() => true)
    setLoading(() => false)
    setHasError(() => undefined)
  }, [form, setForm])

  // console.log(currentUser)

  const send = useCallback(async () => {
    setLoading(true)
    getDeviceInfos()
    await uploadFirestore({
      db,
      currentUser,
      tipoTermo,
      form,
      setLoading,
      setResult,
      setHasError,
      hasError,
      availableTicketsAmmountRef,
      setUserTicket
    })
    await sendUserConsent({
      name: currentUser.nome,
      email: currentUser.email,
      origin: originConsents[tipoTermo]
    })
    setLoading(false)
  }, [
    db,
    currentUser,
    tipoTermo,
    form,
    setLoading,
    setResult,
    setHasError,
    hasError,
    availableTicketsAmmountRef
  ])

  const onBack = useCallback(() => {
    cleanDataState()
    back()
  }, [back, cleanDataState])

  const renderError = useCallback(
    () => (
      <div className="container">
        <div className="titenquete title">
          <p>Ocorreu um erro ao gerar o seu cupom.</p>
          <p>{hasError}</p>
          <p>Por favor, tente novamente.</p>
        </div>
        <div className="btsalvar">
          <button onClick={onBack}>Tente novamente</button>
        </div>
      </div>
    ),
    [hasError, onBack]
  )

  const renderContent = useCallback(() => {
    const showSendFormComponent = (
      <>
        <div className="container">
          <div className="descenquete">{description()}</div>
          <div className="btsalvar">
            <button onClick={send} className="btsalvar" disabled={salvarOk}>
              {availableTicketsAmmount > 0 ? 'Gerar Cupom' : 'Cupons esgotados'}
            </button>
          </div>
        </div>
      </>
    )

    const showSuccessComponent = (
      <div className="container">
        <div className="titenquete title cupom">
          Código gerado com sucesso!
        </div>
        <div className="titenquete content cupom">
          Seu código é
        </div>
        <div className="titenquete cupom code">
          {userTicket}
        </div>
        <div className="titenquete aviso parceiro">
          <p>
            Utilize esse código para fazer a sua <strong>inscrição gratuitamente na MEIA MARATONA DE CURITIBA - CLUBE DA ALICE.</strong><br />
            <i>CATEGORIA STANDARD (com direito a kit).</i>
          </p>
        </div>
        <div className="btsalvar" style={{ textAlign: 'center', marginBottom: '10px' }}>
            <button onClick={() => window.open('https://www.ticketsports.com.br/e/MEIA+MARATONA+DE+CURITIBA+2022+-+CLUBE+DA+ALICE-33722', '_blank')} className="btsalvar">
              FAÇA SUA INSCRIÇÃO
            </button>
        </div>
        <p>Eventuais dúvidas, entre em contato através do email <div style={{ display: 'inline-block', textDecoration: 'underline' }}>eventos@rpc.com.br</div></p>
        <i>Certificado de Autorização SEAE/ME Nº 05.020834/2022</i>
      </div>
    )

    return !result ? showSendFormComponent : showSuccessComponent
  }, [title, description, send, salvarOk, result, userTicket])

  const renderLoading = useCallback(() => {
    return (
      <>
        <div className="container">
          <div className="titenquete title">
            <p>Seu cupom está sendo gerado.</p>
          </div>
          <div className="titenquete content">
            <p>Por favor, não feche esta tela até o processo finalizar.</p>
          </div>
        </div>
        <img src="/imgs/giphy.gif" className="img-loading"/>
      </>
    )
  }, [loading])

  return (
    <React.Fragment>
      <div className="enqueterpc">
        <div className="imagemdestaque">
          <img src={imagePath} alt="banner" />
        </div>
        {hasError ? renderError() : loading ? renderLoading() : renderContent()}
      </div>
    </React.Fragment>
  )
}

export default Base
